import { render } from "./EFaultConfirm.vue?vue&type=template&id=35c88f02"
import script from "./EFaultConfirm.vue?vue&type=script&lang=js"
export * from "./EFaultConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__